import IconOne from "../../images/home/desktop/icon-personal-finances.svg";
import IconTwo from "../../images/home/desktop/icon-banking-and-coverage.svg";
import IconThree from "../../images/home/desktop/icon-consumer-payments.svg";

export const data = [
  {
    icon: IconOne,
    title: "Personal Finances",
    description:
      "Consolidate financial data from multiple sources and categorize transactions up to 2 years of history. Analyze reports to reconcile activities in your account.",
  },
  {
    icon: IconTwo,
    title: "Banking & Coverage",
    description:
      "With our platform, you can speed up account onboarding and support ongoing payments for checking, savings, credit card, and brokerage accounts.",
  },
  {
    icon: IconThree,
    title: "Consumer Payments",
    description:
      "It’s easier to set up secure bank payments with us through a flow designed with the user experience in mind. Customers could instantly authenticate their account.",
  },
];
